import { render } from "./CustomerAvatarUpload.vue?vue&type=template&id=62dc8d61&scoped=true"
import script from "./CustomerAvatarUpload.vue?vue&type=script&lang=js"
export * from "./CustomerAvatarUpload.vue?vue&type=script&lang=js"

import "./CustomerAvatarUpload.vue?vue&type=style&index=0&id=62dc8d61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dc8d61"]])

export default __exports__